import React, { Component } from 'react';
import { StyleSheet, css } from 'aphrodite';
import { Link } from 'react-router';
import { Theme } from '../../config/theme.js';

import TrackControl from '../TrackControl';

export default class VolumeControl extends Component {
  static defaultProps = {
    'volume': 80,
  }

  _toggleMute() {
    this.props.toggleMute();
  }

  _setVolume(e) {
    let domElement = this.progress.getBoundingClientRect();
    let percentage = ((e.pageX - domElement.left) / domElement.width);

    this.props.handler(percentage);
  }

  render() {
    const dynamic_styles = StyleSheet.create({
      progress: {
        position: 'absolute',
        left: 0,
        top: 0,
        width: (this.props.volume) * Theme.player.volume.width,
        height: Theme.player.volume.thickness,
        backgroundColor: Theme.player.volume.played_color,
        transition: 'all 180ms ease-in-out',
      }
    });

    return (
      <div className={css(styles.container)}>
        <TrackControl handler={this._toggleMute.bind(this)} type={this.props.volume > 0 ? 'volume' : 'muted'} />
        <div
          className={css(styles.volume_container)}
          onClick={this._setVolume.bind(this)}
          ref={(ref) => (this.progress = ref)}>
          <div className={css(styles.progress_container)}>
            <div className={css(dynamic_styles.progress)} />
          </div>
        </div>
      </div>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    display: 'flex',
    position: 'relative',
    alignItems: 'center',
  },
  volume_container: {
    position: 'relative',
    cursor: 'pointer',
    width: Theme.player.volume.width,
    height: Theme.player.volume.thickness,
    backgroundColor: Theme.player.volume.color,
  },
  icon: {
    display: 'inline',
    width: 17,
    height: 17,
    marginLeft: 15,
    marginRight: 15,
    cursor: 'pointer',
    ':hover': {
      fill: Theme.primary,
    },
  },
});



// WEBPACK FOOTER //
// ./src/components/VolumeControl/index.js